import { useNavigate } from "react-router-dom";
import style from './index.module.css';
import Footer from '../moduls/footer';
import TextSwitcher from '../moduls/textswitch';
export default function Gpt({login , setLogin,user, setUser}) {
    const navigate = useNavigate();
   

  return (
    <div className={style.page}>
         <div className={style.fire1} />
        
        <div className={`${style.container} ${style.flexminpage}`}>
            <div className={`${style.header} ${style.topsmin}`}>
                <div className={style.logo} onClick={() => navigate("/")}>I’m-GPT</div>
                <div className={style.enter} onClick={() => navigate("/chat?login")}>
                    <img src='img/enter.png' alt='Войти'/>
                    <p>{login ? user?.email : 'Войти'}</p>
                </div>
            </div>
            <div className={`${style.one} ${style.flexpagescroll}`}>
                <h1>I’m-GPT</h1>
                <TextSwitcher/>
                <button className={style.btn} onClick={() => navigate("/chat?register")}>Открыть чат</button>
                <img src='img/anim.gif' alt="anim" className={style.anim}/>
            </div>
            <Footer/>
        </div>
    </div>
  );
}
